import { summaryUI } from './validationSummaryUI';
import { createEventTable, updateEventTable } from './validationTableUI';
let index = 1;
export const validator = (eventsMap) => {
  try {
    // console.info({ eventsMap, index });
    for (const [panel_event_id, eventData] of eventsMap.entries()) {
      let tableStatus = eventData.tableStatus;

      const bothPresent = !!eventData.gv && !!eventData.ga; // both event present at the time table creation
      const isSingle = !eventData.gv || !eventData.ga; // only one event present at the time table creation

      if (!tableStatus) {
        if (bothPresent) eventData.tableStatus = 'done';
        else if (isSingle) eventData.tableStatus = 'single';

        eventData.pos = index;
        createEventTable(eventData, panel_event_id, index);
        summaryUI(index);
        index++;
      } else if (tableStatus === 'single' && bothPresent) {
        eventData.tableStatus = 'done'; // event arrived after some time for same id
        let pos = eventData.pos;
        updateEventTable(eventData, panel_event_id);
        summaryUI(pos);
      } else {
        //tableStatus==='done'
      }
    }
  } catch (e) {
    console.error('SDK_ERROR', e);
  }
};
